module.exports = __webpack_public_path__ + "img/package_5_lock.4a32ecbd.png";